import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css']
})
export class AboutUsComponent implements OnInit {
  programName = environment.productName;

  constructor() { }

  ngOnInit(): void {
    $(this).scrollTop(0);
  }

}
